<template>
    <section>
        <m-art-edit :form.sync="form" :form-rules="rules" :submit-success-func="submitSuccessFunc" :submit-func="submitFunc" label-width="130px">
            <template v-slot:form-items>
                <m-card title="基本信息">
                    <el-row :gutter="24">
                        <el-col :span="12">
                            <el-form-item label="父级菜单" prop="parentMenuId" id='parentMenuId'>
                                <el-select v-model="form.parentMenuId" placeholder="父级菜单">
                                    <el-option :value="null" label="--请选择--"></el-option>
                                    <el-option v-for="(item,index) in parentMenus" :value="item.id" :label="item.menuName" :key="index"></el-option>
                                </el-select>
                            </el-form-item>

                            <el-form-item label="名称" prop="menuName" id='menuName'>
                                <el-input v-model.trim="form.menuName" :maxlength="64" placeholder="名称"></el-input>
                            </el-form-item>

                            <el-form-item label="菜单编号" prop="serverCode" id='serverCode'>
                                <el-input v-model.trim="form.serverCode" :maxlength="64" placeholder="菜单编号"></el-input>
                            </el-form-item>

                            <el-form-item label="URL" prop="menuUrl" id='menuUrl'>
                                <el-input v-model.trim="form.menuUrl" :maxlength="512" placeholder="URL"></el-input>
                            </el-form-item>

                            <el-form-item label="排序编号" prop="orderByNumber">
                                <el-input-number v-model.trim="form.orderId" :max="9999" placeholder="排序编号" controls-position="right"></el-input-number>
                            </el-form-item>

                            <!-- <el-form-item label="图标" prop="icon">
                                <el-input v-model="form.icon" placeholder="图标"></el-input>
                            </el-form-item>

                            <el-form-item label="描述" prop="description">
                                <el-input v-model="form.description" type="textarea" rows="3" placeholder="描述"></el-input>
                            </el-form-item> -->

                            <!-- <el-form-item label="是否启用" prop="isEnable">
                                <el-switch v-model="form.isEnable"></el-switch>
                            </el-form-item> -->

                            <!-- <el-form-item label="是否缓存" prop="isCache">
                                <el-switch v-model="form.isCache"></el-switch>
                            </el-form-item> -->

                            <el-form-item label="是否在菜单栏展示" prop="showInMenu">
                                <el-switch v-model="form.showInMenu"></el-switch>
                            </el-form-item>

                        </el-col>
                    </el-row>
                </m-card>
            </template>
        </m-art-edit>
    </section>
</template>

<script>
import api from "plus/api";
import upload from "components/upload";
import detailsMixin from "@/mixin/detailsMixin";
import dialogEnum from "@/utils/dialogEnum";

export default {
    name: "privilege.menu.details",
    components: { upload },
    mixins: [detailsMixin],
    data() {
        return {
            parentMenus: [],
            form: {
                menuName: "",
                menuUrl: "",
                orderId: 0,
                parentMenuId: null,
                serverCode: "",
                showInMenu: true,
            },
            rules: {
                parentMenuId: [{ required: true, message: "请选择父级菜单" }],
                menuName: [{ required: true, message: "请填写名称" }],
                menuUrl: [{ required: true, message: "请填写菜单地址" }],
                serverCode: [{ required: true, message: "请填写菜单编号" }],
            },
        };
    },
    computed: {
        submitFunc() {
            return this.isEdit
                ? api.manage.updateMenuInfoList
                : api.manage.addMenuList;
        },
    },
    created() {
        api.manage.getFirstLevelMenuList().then((result) => {
            let { data } = result.data || {};
            this.parentMenus = data;
            if (this.isEdit) {
                api.manage
                    .getMenuInfoById({ id: this.$route.query.id })
                    .then((result) => {
                        this.form = Object.assign(this.form, result.data.data);
                        this.form.orderId = result.data.data.orderByNumber;
                    });
            }
        });
    },
    methods: {
        submitSuccessFunc() {
            this.$message.success("提交成功");
        },
    },
};
</script>
<style lang="less" scoped>
.groups {
    display: flex;
    align-items: center;

    i {
        margin: 0 10px;
    }
}
</style>
